module.exports = "/images/file-rotated.svg?9d16471c96245fc2a00c0dfbf7d2f594";